import { useState } from 'react'
import { Button } from '../components/button'
import { DateRange, DateRangePicker, dateRangeToPrimitive } from '../components/daterange-picker'
import { moveRange } from '../dashboard/utils'
import { LocationChange } from './location-change'
import { LocationUtilization } from './location-utilization'
import { VehicleUtilization } from './vehicle-utilization'

const DEFAULT_RANGE = {
	start: 'now-90d/d',
	end: 'now/d',
}

export function Overview() {
	const [range = DEFAULT_RANGE, setRange] = useState<DateRange>(DEFAULT_RANGE)
	const apiRange = dateRangeToPrimitive(range)
	const createMoveRange = (direction: 'plus' | 'minus') => () => setRange(moveRange(direction))

	return (
		<div className="space-y-6">
			<div className="flex justify-start items-end gap-4">
				<Button variant="SECONDARY" onPress={createMoveRange('minus')}>
					◀ Předchozí
				</Button>
				<DateRangePicker
					value={range}
					onChange={setRange}
					label="Období"
					presets="backward"
				/>
				<Button variant="SECONDARY" onPress={createMoveRange('plus')}>
					Další ▶
				</Button>
			</div>
			<VehicleUtilization range={apiRange} />
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
				<LocationUtilization
					range={apiRange}
					locationType="locationFrom"
					title="Vytíženost poboček (odjezd)"
				/>
				<LocationUtilization
					range={apiRange}
					locationType="locationTo"
					title="Vytíženost poboček (příjezd)"
				/>
				<LocationChange range={apiRange} />
			</div>
		</div>
	)
}
